module.exports = __webpack_public_path__ + "static/media/3j_website_logo_coorg_ieee.a25f9396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3j_website_logo_coorg_ieee.jpg
// module id = 50
// module chunks = 0